const defs = [
  {
    title: "Basinställning för avisering",
    key: "INVOICING_BASE",
    visited: true,
    hasError: false,
    fieldKeys: ["setting"],
  },
  {
    title: "Gå vidare",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [""],
  },
];

export default () => {
  return defs;
};
